import * as queryString from 'query-string'
import moment from 'moment'

export type Calendar = Record<string, number>

const getCalendarMappingObject = (ranges: string) => {
  const period = queryString.parse(ranges)
  let calendar: Calendar = {}
  const days: Calendar = {}
  // @ts-ignore
  const m = moment(period.startDate)
  // @ts-ignore
  for (m; m.diff(period.endDate, 'days') <= 0; m.add(1, 'days')) {
    const property = m.format('DD-MM-YYYY')
    days[property] = 0
    calendar = { ...days }
  }
  return calendar
}

export default getCalendarMappingObject
